import {connect} from "react-redux";
import EdiMessagesPage from "./EdiMessagesPage";
import * as ShippingApiActions from "../actions/ShippingApiActions";
import * as ViewActions from "../actions/ViewActions";
import {withRouter} from "react-router";

export default connect(null, {...ViewActions, ...ShippingApiActions})(withRouter(EdiMessagesPage));